define('OutSystems/ClientRuntime/modules/Database/IndexedDB/IndexedDBTransactionWithoutObjectStores',["require", "exports", "tslib", "../../../Logger", "../TableInfoUtils"], function (require, exports, tslib_1, Logger, TableInfoUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var IndexedDBTransactionWithoutObjectStores = (function () {
        function IndexedDBTransactionWithoutObjectStores(allowTraces, database) {
            this.allowTraces = allowTraces;
            this.database = database;
            if (this.allowTraces) {
                Logger.trace(this, "Starting transaction ".concat(this.transactionId, " over ").concat(database.objectStoreNames.length, " store(s)"));
            }
        }
        IndexedDBTransactionWithoutObjectStores.prototype.createTable = function (table) {
            var _this = this;
            return new Promise(function (resolve) {
                _this.trace("Creating table '".concat(table.tableName, "'"));
                var primaryColumns = TableInfoUtils.getIdentifierColumnNames(table);
                var store = _this.database.createObjectStore(table.tableName, {
                    autoIncrement: !primaryColumns,
                    keyPath: primaryColumns,
                });
                _this.trace("Creating columns for '".concat(table.tableName, "' table"));
                for (var i = 0; i < table.attributes.length; i++) {
                    _this.trace("Creating column '".concat(table.attributes[i].name, "'"));
                    store.createIndex(table.attributes[i].columnName, table.attributes[i].columnName);
                }
                resolve();
            });
        };
        IndexedDBTransactionWithoutObjectStores.prototype.deleteTableIfExists = function (table) {
            var _this = this;
            var tableName;
            if (typeof table === "string") {
                tableName = table;
            }
            else {
                tableName = table.tableName;
            }
            return new Promise(function (resolve, reject) {
                _this.trace("Deleting table '".concat(tableName, "'"));
                if (!_this.database.objectStoreNames.contains(tableName)) {
                    _this.trace("Table '".concat(tableName, "' does not exist"));
                    return resolve();
                }
                try {
                    _this.database.deleteObjectStore(tableName);
                    _this.trace("Table '".concat(tableName, "' deleted successfuly"));
                }
                catch (error) {
                    _this.trace("Error deleting table '".concat(tableName, "'"), error);
                    return reject(error);
                }
                resolve();
            });
        };
        IndexedDBTransactionWithoutObjectStores.prototype.existsTable = function (table) {
            var tableName = typeof table === "string" ? table : table.tableName;
            return Promise.resolve(this.database.objectStoreNames.contains(tableName));
        };
        IndexedDBTransactionWithoutObjectStores.prototype.renameTable = function (tableName, newTableName) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.addColumn = function (table, column) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.existsColumn = function (tableName, columnName) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    throw new Error("You can't execute this method on a database without object stores.");
                });
            });
        };
        IndexedDBTransactionWithoutObjectStores.prototype.getRecord = function (table, key) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.insertRecord = function (table, record) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.updateRecord = function (table, record) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.upsertRecord = function (table, record) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.upsertAllRecords = function (table, records) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.removeRecord = function (table, key) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.removeAllRecords = function (table) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.findRecords = function (table, criteria) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.getAllRecords = function (table) {
            throw new Error("You can't execute this method on a database without object stores.");
        };
        IndexedDBTransactionWithoutObjectStores.prototype.trace = function (message, error) {
            if (this.allowTraces) {
                Logger.trace(this, "".concat(message, " on transaction ").concat(this.transactionId).concat(error ? ": ".concat(error.message) : ""));
            }
        };
        return IndexedDBTransactionWithoutObjectStores;
    }());
    exports.default = IndexedDBTransactionWithoutObjectStores;
});
//# sourceMappingURL=IndexedDBTransactionWithoutObjectStores.js.map;
